import type { ComponentType } from "react";
import type { SchemeKey, SchemeManifest } from "@shared/types/foyer";
import type { ResolvedScheme } from "./_shared/schemeContext";
import AtelierScheme from "./atelier/AtelierScheme";
import MosaicScheme from "./mosaic/MosaicScheme";
import SpectrumScheme from "./spectrum/SpectrumScheme";
import CareScheme from "./care/CareScheme";
import AureliaScheme from "./aurelia/AureliaScheme";
import MareaScheme from "./marea/MareaScheme";
import NordScheme from "./nord/NordScheme";
import TerraScheme from "./terra/TerraScheme";
import TannScheme from "./tann/TannScheme";
import {
  atelierManifest,
  mosaicManifest,
  spectrumManifest,
  careManifest,
  aureliaManifest,
  mareaManifest,
  nordManifest,
  terraManifest,
  tannManifest,
} from "@shared/schemes/manifests";

/** Every scheme component takes exactly this - a fully resolved scheme. */
export interface SchemeProps {
  scheme: ResolvedScheme;
}

interface SchemeEntry {
  component: ComponentType<SchemeProps>;
  manifest: SchemeManifest;
}

/**
 * The scheme registry: key → { component, manifest }. Adding a template means
 * dropping a folder under src/tv/schemes/<name>/ (component + manifest) and
 * registering it here. SchemeRouter resolves a premise's binding against the
 * entry's manifest, then renders the component.
 */
export const SCHEME_REGISTRY: Record<SchemeKey, SchemeEntry> = {
  atelier: { component: AtelierScheme, manifest: atelierManifest },
  mosaic: { component: MosaicScheme, manifest: mosaicManifest },
  spectrum: { component: SpectrumScheme, manifest: spectrumManifest },
  care: { component: CareScheme, manifest: careManifest },
  aurelia: { component: AureliaScheme, manifest: aureliaManifest },
  marea: { component: MareaScheme, manifest: mareaManifest },
  nord: { component: NordScheme, manifest: nordManifest },
  terra: { component: TerraScheme, manifest: terraManifest },
  tann: { component: TannScheme, manifest: tannManifest },
};

// Manifest-only consumers (e.g. the CMS editor) import SCHEME_MANIFESTS from
// "@shared/schemes/manifests" directly - no need to pull in the TV components.
